import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1623">
      {/* Header with logo */}
      <header className="w-full bg-[#1a0647] px-6 py-4" data-id="element-1624">
        <div className="max-w-4xl mx-auto flex items-center" data-id="element-1625">
          <Link to="/" className="flex-shrink-0" data-id="element-1626">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-5" data-id="element-1627" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-6 pt-6 pb-10" data-id="element-1628">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-1629">
          {/* Heading */}
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-1 tracking-tight" data-id="element-1630">
            Digital Risk Assessment
          </h1>
          <p className="text-gray-500 text-base md:text-lg mb-6" data-id="element-1631">
            Get a personalized plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-6" data-id="element-1632">
            <div className="flex flex-col items-center" data-id="element-1633">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1634">
                <ClipboardCheckIcon size={24} className="text-gray-400" data-id="element-1635" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1636">
                Assess
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1637" />

            <div className="flex flex-col items-center" data-id="element-1638">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1639">
                <BookOpenIcon size={24} className="text-gray-400" data-id="element-1640" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1641">
                Inform
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1642" />

            <div className="flex flex-col items-center" data-id="element-1643">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1644">
                <ShieldCheckIcon size={24} className="text-gray-400" data-id="element-1645" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1646">
                Secure
              </span>
            </div>
          </div>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-1647">
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1648">
              <span className="text-xl flex-shrink-0" data-id="element-1649">🏠</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1650">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1651">
              <span className="text-xl flex-shrink-0" data-id="element-1652">🔐</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1653">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1654">
              <span className="text-xl flex-shrink-0" data-id="element-1655">📱</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1656">
                Devices
              </span>
            </div>
            <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1657">
              <span className="text-xl flex-shrink-0" data-id="element-1658">🛡️</span>
              <span className="ml-2 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1659">
                Privacy
              </span>
            </div>
          </div>

          {/* Start Assessment button */}
          <Link to="/assessment" className="bg-[#631bb7] text-white px-6 py-2.5 rounded-lg font-bold text-lg no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1660">
            Start Assessment
          </Link>
        </div>
      </div>
    </div>;
}